import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';

interface PrivateRouteProps {
  /**
   * This holds the routing path
   */
  path: string;
  /**
   * This hold the react component to load for each route
   */
  component: React.ComponentType<any>;

  /**
   * This hold the exact route matcher if provided
   */
  exact?: boolean;
}

export const PrivateRoute = ({ component: Component, ...rest }: PrivateRouteProps) => (
  <Route
    {...rest}
    render={(props) =>
      Cookies.get('adminDetails') ? (
        <>
          <Header />
          <div className="App">
            <div className="App__routing-page-holder">
              <Component {...props} />
            </div>
          </div>
          <Footer />
        </>
      ) : (
        <Redirect to="/login" />
      )
    }
  ></Route>
);

export default PrivateRoute;
